import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { AuthenticationService } from './authentication.service';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { User } from '../../interfaces/routering/user';

@Injectable()

export class AuthorizationService implements CanActivate, CanActivateChild {
  constructor(private router: Router,
              private titleService: Title,
              private authenticationService: AuthenticationService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationService.user$.pipe(
      map((user: User): boolean => this.allowAccess(user, state, next))
    );
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationService.user$.pipe(
      map((user: User): boolean => this.allowAccess(user, state, next))
    );
  }

  allowAccess(user: User, state: RouterStateSnapshot, next: ActivatedRouteSnapshot): boolean {
    if (user) {
      const permissions: string[] = next.data['permissions'] as Array<string>,
        title: string = next.data['title'] + ' | ' + environment.webappName;

      // if user is super-admin, allow access
      if (user.role === 'super-admin') {
        this.titleService.setTitle(title);
        return true;
      }

      // is user from external contractor and did agree with required contractor agreement?
      if (typeof user.is_external_contractor !== 'undefined' && typeof user.external_contractor_agreement_id !== 'undefined') {
        if (user.is_external_contractor && !user.external_contractor_agreement_id && state.url !== '/auth/verwerkersovereenkomst') {
          this.router.navigate(['/auth/verwerkersovereenkomst']).then((): void => {
          });
          return false;
        }
      }

      // does user want to access /auth/verwerkersovereenkomst but already agreed?
      if (typeof user.external_contractor_agreement_id !== 'undefined') {
        if (state.url === '/auth/verwerkersovereenkomst' && user.external_contractor_agreement_id) {
          this.router.navigate(['/']).then((): void => {
          });
          return false;
        }
      }

      // check if user has required permissions, before allowing access
      if (typeof permissions !== 'undefined') {
        if (permissions.length) {
          if (permissions.some((permission: string) => user.permissions.includes(permission))) {
            this.titleService.setTitle(title);
            return true;
          } else {
            this.router.navigate([`/handleiding`]).then((): void => {
            });
            return false;
          }
        } else {
          this.titleService.setTitle(title);
          return true;
        }
      } else {
        this.titleService.setTitle(title);
        return true;
      }
    } else {
      this.router.navigate([`/auth/login`], {queryParams: {returnUrl: state.url}}).then((): void => {
      });
      return false;
    }
  }
}
